import { Vestimenta } from "../../components";
import "./stylesCategoriaVestimenta.scss";

export const CategoriaVestimenta = () => (
  <div>
    <Vestimenta />
  </div>
);
